import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("dt", { class: "text-sm font-medium text-gray-500" }, "Name of candidate offered:", -1);
const _hoisted_3 = { class: "mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2" };
const _hoisted_4 = { class: "py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6" };
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("dt", { class: "text-sm font-medium text-gray-500" }, "Current Stage:", -1);
const _hoisted_6 = { class: "mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2" };
const _hoisted_7 = { class: "py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6" };
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("dt", { class: "text-sm font-medium text-gray-500" }, "Current Assignee:", -1);
const _hoisted_9 = { class: "mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2" };
const _hoisted_10 = { class: "py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6" };
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("dt", { class: "text-sm font-medium text-gray-500" }, "Status:", -1);
const _hoisted_12 = { class: "mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2" };
const _hoisted_13 = {
    key: 0,
    class: "w-full flex justify-end"
};
import { computed, inject, onBeforeMount, ref } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import ActivityFeed from '@/components/activityFeed.vue';
import AmendContractDetails from '@/components/approvalWorkflowForms/AmendContractDetails.vue';
import candidateDetails from '@/components/approvalWorkflowForms/candidateDetails.vue';
import formTwelve from '@/components/approvalWorkflowForms/firstSecondApproval.vue';
import formfifteen from '@/components/approvalWorkflowForms/preContractual.vue';
import salaryOvertime from '@/components/approvalWorkflowForms/salaryOvertimeForm.vue';
import formEight from '@/components/create-starter/formEight.vue';
import formEleven from '@/components/create-starter/formEleven.vue';
import formFive from '@/components/create-starter/formFive.vue';
import formFour from '@/components/create-starter/formFour.vue';
import formNine from '@/components/create-starter/formNine.vue';
import formOne from '@/components/create-starter/formOne.vue';
import formSeven from '@/components/create-starter/formSeven.vue';
import formSix from '@/components/create-starter/formSix.vue';
import formTen from '@/components/create-starter/formTen.vue';
import formThree from '@/components/create-starter/formThree.vue';
import formTwo from '@/components/create-starter/formTwo.vue';
import httpClient from '@/httpClient';
import formLayout from '@/layouts/formLayout.vue';
import { saveStorage } from '@/storageSave';
export default /*#__PURE__*/ _defineComponent({
    __name: 'step13OfferHR',
    setup(__props) {
        const store = useStore();
        const router = useRouter();
        const formPoint = ref(0);
        const navItemConfig = [
            {
                formPoint: 0,
                name: 'checks',
                text: 'Pre-Contractual Checks',
                component: formfifteen,
                icon: 'UserIcon',
            },
            {
                formPoint: 1,
                name: 'candidate',
                text: 'Candidate Details',
                component: candidateDetails,
                icon: 'UserIcon',
            },
            {
                formPoint: 2,
                name: 'contractAmend',
                text: 'Confirm Contract Details',
                component: AmendContractDetails,
                icon: 'UserIcon',
            },
            {
                formPoint: 3,
                name: 'salary',
                text: 'Salary and Overtime Details',
                component: salaryOvertime,
                icon: 'UserIcon',
            },
            {
                formPoint: 4,
                name: 'formOne',
                text: 'Hiring Manager & Secondary Contact Details',
                component: formOne,
                icon: 'UserIcon',
            },
            {
                formPoint: 5,
                name: 'formTwo',
                text: 'Recruitment Reason',
                component: formTwo,
                icon: 'LogoutIcon',
            },
            {
                formPoint: 6,
                name: 'formThree',
                text: 'Job Details',
                component: formThree,
                icon: 'EmojiHappyIcon',
            },
            {
                formPoint: 7,
                name: 'formFour',
                text: 'Organisation Details',
                component: formFour,
                icon: 'DocumentTextIcon',
            },
            {
                formPoint: 8,
                name: 'formFive',
                text: 'Working Hours',
                component: formFive,
                icon: 'DocumentTextIcon',
            },
            {
                formPoint: 9,
                name: 'formSix',
                text: 'Contract Details',
                component: formSix,
                icon: 'DocumentTextIcon',
            },
            {
                formPoint: 10,
                name: 'formSeven',
                text: 'Advertising Requirements',
                component: formSeven,
                icon: 'DocumentTextIcon',
            },
            {
                formPoint: 11,
                name: 'formEight',
                text: 'Pre Employment Checks',
                component: formEight,
                icon: 'DocumentTextIcon',
            },
            {
                formPoint: 12,
                name: 'formNine',
                text: 'Security',
                component: formNine,
                icon: 'DocumentTextIcon',
            },
            {
                formPoint: 13,
                name: 'formTen',
                text: 'Specialist Roles',
                component: formTen,
                icon: 'DocumentTextIcon',
            },
            {
                formPoint: 14,
                name: 'formEleven',
                text: 'Attachments',
                component: formEleven,
                icon: 'UserCircleIcon',
            },
            {
                formPoint: 15,
                name: 'formTwelve',
                text: 'First & Second Line Approval',
                component: formTwelve,
                icon: 'DocumentTextIcon',
            },
        ];
        const formData = ref({
            checks: {},
            adminOwner: {},
            candidate: {},
            contractAmend: {},
            salary: {},
            formOne: {},
            formTwo: {},
            formThree: {},
            formFour: {},
            formFive: {},
            formSix: {},
            formSeven: {},
            formEight: {},
            formNine: {},
            formTen: {},
            formEleven: {},
            formTwelve: {},
        });
        const configItems = ref({});
        const stages = inject('stages', []);
        const disableForm = computed(() => currentNavItem.value?.name !== 'checks' &&
            currentNavItem.value?.name !== 'clearances');
        const currentStage = computed(() => stages.find((stage) => stage.stageName === formData.value.currentStageName));
        const profile = computed(() => store.getters.getProfile);
        const currentNavItem = computed(() => navItemConfig.find((item) => item.formPoint === formPoint.value));
        const setCurrentNavItem = (value) => {
            formPoint.value = value;
        };
        const handleSubmitForm = async ({ name, data, }) => {
            try {
                store.dispatch('setIsLoading', true);
                formData.value[name].saved = true;
                const payload = {
                    formData: { ...data },
                    requestedBy: docOwner.value,
                    id: docId.value,
                    stage: formData.value.currentStageName,
                };
                const res = await httpClient.post(`/bff/starter/${name}`, payload);
                formData.value = res.data.body?.Item ?? {};
                saveStorage('formData', JSON.stringify(formData.value));
                store.dispatch('setNotificationAll', {
                    visible: true,
                    type: 'success',
                    title: 'SAVED!',
                    message: 'The form has been saved.',
                });
                router.push('/');
                store.dispatch('setIsLoading', false);
            }
            catch (err) {
                console.log(err);
                formData.value[name].saved = false;
                store.dispatch('setNotificationAll', {
                    visible: true,
                    type: 'error',
                    title: 'Error!',
                    message: 'There was an error submitting the form',
                });
                store.dispatch('setIsLoading', false);
            }
        };
        const handleUpdateFormData = (event) => {
            formData.value[event.formName] = event.formData;
            saveStorage('formData', JSON.stringify(formData.value));
        };
        const docId = computed(() => router.currentRoute.value.params.id);
        const docOwner = computed(() => router.currentRoute.value.params.docOwner);
        const fetchFormData = async () => {
            const response = await httpClient.post('/bff/get-document', {
                id: docId.value,
                requestedBy: docOwner.value,
            });
            formData.value = response.data.body?.Item ?? {};
            saveStorage('formData', JSON.stringify(formData.value));
        };
        const fetchConfigItems = async () => {
            const response = await httpClient.post('/config/all', {
                requestedBy: 'something',
            });
            configItems.value = response.data.body;
        };
        const cancelOffer = async () => {
            store.dispatch('setIsLoading', true);
            await httpClient.post('/bff/cancel-offer', {
                requestedBy: profile.value.userID,
                id: formData.value.docId,
                docOwner: formData.value.requestedBy,
            });
            router.push('/');
            store.dispatch('setIsLoading', false);
        };
        const handleReassign = () => {
            const id = formData.value.docId;
            const docOwner = formData.value.requestedBy;
            router.push(`/re-assign/${id}/${docOwner}`);
        };
        onBeforeMount(async () => {
            await fetchFormData();
            await fetchConfigItems();
        });
        return (_ctx, _cache) => {
            return (formData.value)
                ? (_openBlock(), _createBlock(formLayout, {
                    key: 0,
                    "nav-item-config": navItemConfig,
                    "current-nav-item": currentNavItem.value,
                    "form-point": formPoint.value,
                    "form-data": formData.value,
                    "form-name": "leaverForm",
                    "display-header": true,
                    "display-timeline": formData.value.currentStageName === 'offer.notifyMakeOffer' ||
                        formData.value.currentStageName === 'offer.notifyOfferSent' ||
                        formData.value.currentStageName === 'offer.complete',
                    onSetCurrentNavItem: setCurrentNavItem
                }, {
                    pageTitle: _withCtx(() => [
                        _createTextVNode("Offer")
                    ]),
                    header: _withCtx(() => [
                        _createElementVNode("div", _hoisted_1, [
                            _hoisted_2,
                            _createTextVNode(),
                            _createElementVNode("dd", _hoisted_3, _toDisplayString(formData.value.candidateName), 1)
                        ]),
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_4, [
                            _hoisted_5,
                            _createTextVNode(),
                            _createElementVNode("dd", _hoisted_6, _toDisplayString(currentStage.value?.displayName), 1)
                        ]),
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_7, [
                            _hoisted_8,
                            _createTextVNode(),
                            _createElementVNode("dd", _hoisted_9, _toDisplayString(formData.value.atr?.formOne?.hiringManagerEmail ?? formData.value.currentAssigneeEmail), 1)
                        ]),
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_10, [
                            _hoisted_11,
                            _createTextVNode(),
                            _createElementVNode("dd", _hoisted_12, _toDisplayString(formData.value.status), 1)
                        ]),
                        _createTextVNode(),
                        ((profile.value.ADMIN || formData.value.requestedBy === profile.value.userID) && formData.value.status !== 'CANCELLED')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                _createElementVNode("button", {
                                    class: "text-center px-4 py-2 rounded-md text-white bg-green-700 hover:underline focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500 bg-no-repeat",
                                    onClick: _withModifiers(handleReassign, ["prevent"])
                                }, "Re-assign"),
                                _createTextVNode(),
                                _createElementVNode("button", {
                                    type: "button",
                                    class: "ml-2 inline-flex items-center justify-center rounded-md border border-transparent bg-red-700 hover:bg-red-800 hover:underline px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-green-800 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto",
                                    onClick: cancelOffer
                                }, "Cancel Offer")
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    main: _withCtx(() => [
                        (_openBlock(), _createBlock(_resolveDynamicComponent(currentNavItem.value?.component), {
                            data: formData.value,
                            "form-data": formData.value[currentNavItem.value?.name] || formData.value.atr[currentNavItem.value?.name],
                            "show-approval-steps": disableForm.value,
                            "disable-form": disableForm.value,
                            "config-items": configItems.value,
                            "config-data": configItems.value,
                            document: formData.value,
                            "onUpdate:formData": handleUpdateFormData,
                            onSubmitForm: handleSubmitForm
                        }, null, 40, ["data", "form-data", "show-approval-steps", "disable-form", "config-items", "config-data", "document"]))
                    ]),
                    timeline: _withCtx(() => [
                        (formData.value.activityList)
                            ? (_openBlock(), _createBlock(ActivityFeed, {
                                key: 0,
                                "activity-list": formData.value?.activityList
                            }, null, 8, ["activity-list"]))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                }, 8, ["current-nav-item", "form-point", "form-data", "display-timeline"]))
                : _createCommentVNode("", true);
        };
    }
});
